// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"567":"dd67005b","665":"a20a5ccb"}[chunkId] + ".chunk.css";
};